<template>

  <div class="recycle_container">
    <div class="detail_top" ref="pagesRef">
      <el-carousel :height="pagesHeight + 'px'" :autoplay="true" :interval="5000">
        <el-carousel-item v-for="(item,index) in detailImgList" :key="index">
          <img class="imgCls" :src="item.url">
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="detail_center_one">
      <div class="center_one_title">
        <div class="center_one_title_line"></div>
        <div class="center_one_title_content">晨检机</div>
        <div class="center_one_title_line"></div>
      </div>

      <div class="center_one_body_current">
        <img style="width: 73%" class="oneBodyImgCls" src="../../assets/images/cj9100_center_001.png"/>
      </div>

    </div>

    <div class="detail_center_two">

      <div class="center_two_a">
        <div class="center_two_a_left"></div>
        <div class="center_two_a_right"></div>
      </div>

      <div class="center_two_b">
        <div class="center_two_b_left"></div>
        <div class="center_two_b_center">晨检机</div>
        <div class="center_two_b_right"></div>
      </div>

      <div class="center_two_c">
        <div class="center_two_c_a">
          晨检，是每个幼儿园都必须执行的一项重要的保健措施，是保证幼儿健康成长的重要关口。幼儿园智能晨检机器人是一款专业的智能晨检解决方案，具备高准确率的智慧图像识别能力和体温探测能力。
          <br>——整机结构采用一体式金属外壳、底部滚轮，内部有显示屏、触摸屏、内置电池、摄像头*1、喇叭、刷卡模块、4G/WiFi天线、红外测温、语音识别、身高体重模块等组成。
        </div>
      </div>

      <div class="center_two_d">外观尺寸</div>
      <div class="center_two_e">机身尺寸：510mm(长)*510mm(宽)*1109mm(高)</div>
      <div class="center_two_e">底座尺寸：1380mm(长)*360mm(宽)*50mm(高)</div>
      <div class="center_two_e">刷卡做尺寸：311mm(长)*160mm(宽)*745mm(高)</div>
      <div class="center_two_e">总尺寸：1390mm(长)*685mm(宽)*1109mm(高)</div>

      <div class="center_other_adorn_right">
        <img class="adorn_img" src="../../assets/images/home_center_adorn.png">
      </div>

      <div class="center_two_d">应用场景</div>
      <div class="center_two_e">
        居民社区，公共场所，学校，办公场所
      </div>

      <div class="center_two_d">功能</div>
    </div>

    <div class="detail_center_three">
      <div class="center_three_body_left">
        <div class="three_body_left_left_double">晨检</div>
        <div class="three_body_left_right">高效完成晨检：2秒钟完成帮助老师完成晨检，提高老师晨检效率；</div>
      </div>

      <div class="center_three_body_right">
        <div class="three_body_right_left_double">快速<br/>成像</div>
        <div class="three_body_right_right">快速成像留存：在自动探测幼儿体表温度的同时，对幼儿局部进行快速成像展示并留存，方便管 理者追溯及统计分析；
        </div>
      </div>

      <div class="center_three_body_left">
        <div class="three_body_left_left_double">家校<br/>互联</div>
        <div class="three_body_left_right">智慧健康家校互联：幼儿家长可每天实时接收到自己孩子的晨检报告和数据，加强了家校健康疾控互动；</div>
      </div>

      <div class="center_three_body_right">
        <div class="three_body_right_left_double">数据<br/>分析</div>
        <div class="three_body_right_right" style="text-align: right">云端数据分析管 理：所有晨检数据实时上传云端，并进行数据整合分析，管 理一目了然；</div>
      </div>

      <div class="center_three_body_left">
        <div class="three_body_left_left_double">考勤<br/>签到</div>
        <div class="three_body_left_right">考勤签到功能：推送入园离园考勤信息到管 理者端、老师端、家长端；</div>
      </div>

      <div class="center_three_body_right">
        <div class="three_body_right_left_double">内置<br/>电池</div>
        <div class="three_body_right_right">内置电池方便移动：本设备内置锂电池，外部适配器断开的情况下，也能续航工作；同时自带滚轮，方便移动，轻便不费力。</div>
      </div>

    </div>

    <div class="detail_center_four">
      <img style="width: 56%;margin: 32px 0" src="../../assets/images/cj9100_center_002.png"/>
    </div>

  </div>

</template>

<script>

export default {
  data() {
    return {
      pagesHeight: "",
      detailImgList: [
        {
          url: require("../../assets/images/fk4151_top_001.png")
        }
      ]
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.pagesHeight = this.$refs.pagesRef.clientHeight;
    })

  },
}
</script>

<style lang="less" scoped>

@import "../../assets/css/detailCommonSecond";

@media screen and (max-width: 1280px) {

  .center_one_body_current {
    height: 552px;

    .oneBodyImgCls {
      width: 100%;
      height: 552px;
    }

  }

}

@media screen and (min-width: 1281px) and (max-width: 1440px) {

  .center_one_body_current {
    height: 637px;

    .oneBodyImgCls {
      width: 100%;
      height: 637px;
    }
  }

}

@media screen and (min-width: 1441px) and (max-width: 1920px) {

  .center_one_body_current {
    height: 829px;

    .oneBodyImgCls {
      width: 100%;
      height: 829px;
    }
  }
}

.center_one_body_current {
  display: flex;
  flex-direction: row-reverse;

  .oneBodyImgCls {
  }
}

</style>